// Dashboard.js
import * as React from 'react';
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from './components/AppNavbar';
import Header from './components/Header';
import SideMenu from './components/SideMenu';
import AppTheme from './shared-theme/AppTheme';
import LinearProgress from '@mui/material/LinearProgress';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";
import { useEffect } from "react";
import { useGrowSetup } from './GrowSetupContext';
import { AuthContext } from "./components/signin/AuthContext";
import { useContext } from "react";

const xThemeComponents = {
  ...require('./theme/customizations').chartsCustomizations,
  ...require('./theme/customizations').dataGridCustomizations,
  ...require('./theme/customizations').datePickersCustomizations,
  ...require('./theme/customizations').treeViewCustomizations,
};

export default function Dashboard(props) {
  const { grow_setup, setGrowSetup } = useGrowSetup();
  const { token, setToken } = useContext(AuthContext);
  useEffect(() => {
    console.log("Inside Dashboard - grow_setup:", grow_setup);
  }, [grow_setup]);

  const GrowSetupBarContainer = styled("div")({
    display: 'flex',
    height: '90px',
    padding: '35px 16px',
    alignItems: 'flex-start',
  });

  const GrowPhaseBalken = styled("div")({
    display: 'flex',
    width: 'hug',
    height: 'hug',
    flexDirection: 'column',
    alignItems: 'center',
  });

  const navigate = useNavigate();
  const tokenIsValid = (token) => {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return currentTime < decodedToken.exp;
  };

  
  if (!token || !tokenIsValid(token)) {
    localStorage.setItem("authenticated", false);
    localStorage.setItem("token", "")
    
    props.removeToken();
    return (<Navigate to="/" />);
  }

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu token={props.token} removeToken={props.removeToken} grow_setup={grow_setup} setGrowSetup={setGrowSetup} menu_index={props.menu_index} />
        <AppNavbar token={props.token} removeToken={props.removeToken} grow_setup={grow_setup} setGrowSetup={setGrowSetup} />
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header />
            <Typography component="h3" variant="h10">
              Grow Phasen
            </Typography>
            <Outlet />
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}